import { WebTypographyStyled } from './WebTypography.styled';
import { PropsFrom } from '@utils/types/propFrom';

export type WebTypographyProps = PropsFrom<typeof WebTypographyStyled>;

export const WebTypography = (props: WebTypographyProps) => <WebTypographyStyled {...props} />;
